import store from '../../store'
import createAxios from './api'

const PATH = '/rssp/v1/devices'

export default {
  async createDevice(req) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH
    await axios.post(fullurl, req)
  },

  async getDevice(id) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH + '/' + `${id}`
    const resp = await axios.get(fullurl)

    return resp.data
  },

  async listMyDevices(q, pageRequest) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH + '/self'

    const resp = await axios.get(fullurl, {
      params: {
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async listDevices(userId, q, pageRequest) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH
    const resp = await axios.get(fullurl, {
      params: {
        userId,
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async updateDevice(id, req) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH + `/${id}`
    await axios.put(fullurl, req)
  },

  async deleteDevice(id) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH + `/${id}`
    await axios.delete(fullurl)
  }
}
